export const PROXY_ENDPOINTS = {
  EXPLORE: 'explore-api',
  FITADVISOR: 'fit-advisor-api',
  KONG_API: 'kong-api',
};
